import list from './list.js'
import edit from './edit.js'

var index = {
    data() {
        return {

        }
    },
    fetch() {

    },
    modules: {
        list,
        edit
    }
}

export default index;